if (!customElements.get('rs-cart-recommendations')) {
  customElements.define('rs-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this._load();
      this._onCartUpdated = (e) => {
        if (e.detail.isEmpty) {
          this._clear();
        } else {
          this._load();
        }
      };
      document.addEventListener('rs:cart:updated', this._onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('rs:cart:updated', this._onCartUpdated);
    }

    async _load() {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
      if (!cart || !cart.items.length) { this._clear(); return; }

      // Try each cart item (newest first = index 0) for shop_the_look metafield
      for (const item of cart.items) {
        const url = `/products/${item.handle}?section_id=${sectionId}`;
        const html = await fetch(url).then(r => r.text()).catch(() => '');
        if (html.trim()) {
          this._inject(html);
          return;
        }
      }

      // All metafields empty — use pre-rendered fallback
      this._useFallback();
    }

    _inject(html) {
      // Remove any existing slider content (keep <template> intact)
      this.querySelectorAll(':not(template)').forEach(el => el.remove());
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      while (wrapper.firstChild) this.appendChild(wrapper.firstChild);

      const slider = this.querySelector('slider-component');
      if (slider && !slider.flkty) slider.connectedCallback?.();
    }

    _useFallback() {
      const tmpl = this.querySelector('template[data-fallback]');
      if (!tmpl) { this._clear(); return; }

      // Check fallback has actual cards
      const clone = tmpl.content.cloneNode(true);
      if (!clone.querySelector('quick-add-product')) { this._clear(); return; }

      this.querySelectorAll(':not(template)').forEach(el => el.remove());
      this.appendChild(clone);

      const slider = this.querySelector('slider-component');
      if (slider && !slider.flkty) slider.connectedCallback?.();
    }

    _clear() {
      this.querySelectorAll(':not(template)').forEach(el => el.remove());
    }
  });
}
